import {
  ORDER_API_APPLY_COUPON,
  ORDER_API_EXPORT,
  ORDER_API_SEARCH_MY_ORDER,
  ORDER_PAYMENT_API,
} from "./../../shared/constants/api-endpoint";
import {
  ORDER_API,
  ORDER_API_CALCULATE_SHIPPING_FEE,
  ORDER_API_SEARCH,
} from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import { PagedResult } from "states/paged-result-model";
import { SearchOrderRequestModel, OrderModel } from "./order.models";

export const searchOrder = async (
  searchOrderRequestModel: SearchOrderRequestModel
) => {
  const createResponse = await apiClient.postHttp<PagedResult<OrderModel>>(
    `${ORDER_API_SEARCH}`,
    searchOrderRequestModel
  );
  return createResponse;
};

export const exportOrder = async (
  searchOrderRequestModel: SearchOrderRequestModel
) => {
  const createResponse = await apiClient.postHttp<string>(
    `${ORDER_API_EXPORT}`,
    searchOrderRequestModel
  );
  return createResponse;
};

export const getOrderById = async (id: string) => {
  return await apiClient.getHttp<OrderModel>(`${ORDER_API}/${id}`);
};

export const assignOrderStaffAPI = async (id: string, staffId: number) => {
  return await apiClient.postHttp<string>(
    `${ORDER_API}/${id}/assign_staff`,
    undefined,
    { params: { staffId } }
  );
};

export const updateOrderCancelAPI = async (id: string) => {
  return await apiClient.postHttp(`${ORDER_API}/${id}/cancel_order`, {});
};

export const verifyOrderAPI = async (id: string) => {
  return await apiClient.postHttp(`${ORDER_API}/${id}/verify_order`, {});
};

export const completeOrderPaymentAPI = async (orderPaymentId: string) => {
  return await apiClient.postHttp(
    `${ORDER_PAYMENT_API}/${orderPaymentId}/complete`
  );
};
